import React from 'react';
import { Route, Routes } from 'react-router-dom';
import StationsPage from './StationsPage';

const StationFormNavigate = React.lazy(() => import('./Station/Form/Form.Navigate'));
const StationRouter = React.lazy(() => import('./Station/Router.Station'));

export default function StationsRouter() {
  return (
    <Routes>
      <Route path="/" element={<StationsPage />} />
      <Route path=":stationId" element={<StationFormNavigate />} />
      <Route path=":stationId/*" element={<StationRouter />} />
    </Routes>
  );
}
